import Client from '../HttpClient';

import { systemSourceUrl } from '../../helpers/SystemSourceHelper';

const list = (systemSource, data) => {
	return Client.get(systemSourceUrl(systemSource, '/order/list'), data);
};

const find = (systemSource, OnlineOrderId) => {
	return Client.get(systemSourceUrl(systemSource, `/order/${OnlineOrderId}`));
};

const findReturnItem = (systemSource, id) => {
	return Client.get(
		systemSourceUrl(systemSource, `/api/vs/manager/return_item/${id}`)
	);
};

const addNote = (systemSource, val) => {
	return Client.post(systemSourceUrl(systemSource, '/order/update/note'), val);
};

const getOrderRefund = (systemSource, OnlineOrderId, val) => {
	return Client.get(
		systemSourceUrl(
			systemSource,
			`/api/vs/manager/order_refunds/${OnlineOrderId}`
		),
		val
	);
};

const getOrderReturnApply = (systemSource, OnlineOrderId, val) => {
	return Client.get(
		systemSourceUrl(
			systemSource,
			`/api/vs/manager/return_apply/${OnlineOrderId}`
		),
		val
	);
};

const getOrderOperateHistory = (systemSource, OnlineOrderId) => {
	return Client.get(
		systemSourceUrl(systemSource, `/order-history/list/${OnlineOrderId}`)
	);
};

const getOrderSettings = (systemSource, data) => {
	return Client.get(systemSourceUrl(systemSource, '/orderSetting'), data);
};

const updateOrderSettings = (systemSource, data) => {
	return Client.post(
		systemSourceUrl(systemSource, '/orderSetting/update'),
		data
	);
};

const getPreparationTimeList = (systemSource, data) => {
	return Client.get(
		systemSourceUrl(systemSource, '/api/vs/manager/omsPreparationSettings'),
		data
	);
};

const addPreparationTime = (systemSource, data) => {
	return Client.post(
		systemSourceUrl(systemSource, '/api/vs/manager/omsPreparationSettings'),
		data
	);
};

const updatePreparationTime = (systemSource, id, data) => {
	return Client.put(
		systemSourceUrl(
			systemSource,
			`/api/vs/manager/omsPreparationSettings/${id}`
		),
		data
	);
};

const deletePreparationTime = (systemSource, id, data) => {
	return Client.del(
		systemSourceUrl(
			systemSource,
			`/api/vs/manager/omsPreparationSettings/${id}`
		),
		data
	);
};

const getDeliveryTimeList = (systemSource, data) => {
	return Client.get(
		systemSourceUrl(systemSource, '/api/vs/manager/omsDeliveryTimeSettings'),
		data
	);
};

const addDeliveryTimeSingle = (systemSource, data) => {
	return Client.post(
		systemSourceUrl(systemSource, '/api/vs/manager/omsDeliveryTimeSetting'),
		data
	);
};

const addDeliveryTime = (systemSource, data) => {
	return Client.post(
		systemSourceUrl(systemSource, '/api/vs/manager/omsDeliveryTimeSettings'),
		data
	);
};

const updateDeliveryTime = (systemSource, id, data) => {
	return Client.put(
		systemSourceUrl(
			systemSource,
			`/api/vs/manager/omsDeliveryTimeSettings/${id}`
		),
		data
	);
};

const deleteDeliveryTime = (systemSource, id, data) => {
	return Client.del(
		systemSourceUrl(
			systemSource,
			`/api/vs/manager/omsDeliveryTimeSettings/${id}`
		),
		data
	);
};

const getSpecialDay = (systemSource, data) => {
	return Client.get(
		systemSourceUrl(
			systemSource,
			'/api/vs/manager/omsDeliveryTimeSettings/day'
		),
		data
	);
};

const loadMerchantList = () => {
	return Client.get('/gateway/echidna-api/api/vs/resource/eagle-mgt');
};

const loadBranchList = (merchantId) => {
	return Client.get(
		`/gateway/echidna-api/api/vs/user/online-order/branch/${merchantId}`
	);
};

const mgtBranchListCheckLicense = (systemSource, data) => {
	return Client.post(
		systemSourceUrl(systemSource, '/api/vs/manager/branches/checkLicense'),
		data
	);
};

const deliveryMethodList = (systemSource, merchantId, data) => {
	return Client.get(
		systemSourceUrl(
			systemSource,
			`/api/vs/manager/${merchantId}/merchantDeliveryMethods`
		),
		data
	);
};

const deliveryFeeList = (systemSource, merchantId, data) => {
	return Client.get(
		systemSourceUrl(
			systemSource,
			`/api/vs/manager/${merchantId}/merchantDeliveryFees`
		),
		data
	);
};

const payMethodList = (systemSource, merchantId, data) => {
	return Client.get(
		systemSourceUrl(
			systemSource,
			`/api/vs/manager/${merchantId}/merchantPaymentMethods`
		),
		data
	);
};

const updateBranchOnline = (systemSource, data) => {
	return Client.put(
		systemSourceUrl(systemSource, '/api/vs/manager/branch'),
		data
	);
};

const updateDeliveryMethod = (systemSource, merchantId, id, data) => {
	return Client.put(
		systemSourceUrl(
			systemSource,
			`/api/vs/manager/${merchantId}/merchantDeliveryMethods/${id}`
		),
		data
	);
};

const addDeliveryMethod = (systemSource, merchantId, data) => {
	return Client.post(
		systemSourceUrl(
			systemSource,
			`/api/vs/manager/${merchantId}/merchantDeliveryMethods`
		),
		data
	);
};

const addDeliveryFee = (systemSource, merchantId, data) => {
	return Client.post(
		systemSourceUrl(
			systemSource,
			`/api/vs/manager/${merchantId}/merchantDeliveryFees`
		),
		data
	);
};

const updateDeliveryFee = (systemSource, merchantId, id, data) => {
	return Client.put(
		systemSourceUrl(
			systemSource,
			`/api/vs/manager/${merchantId}/merchantDeliveryFees/${id}`
		),
		data
	);
};

const deleteDeliveryFee = (systemSource, merchantId, id, data) => {
	return Client.del(
		systemSourceUrl(
			systemSource,
			`/api/vs/manager/${merchantId}/merchantDeliveryFees/${id}`
		),
		data
	);
};

const getProfileOption = (systemSource, merchantId, data) => {
	return Client.get(
		systemSourceUrl(
			systemSource,
			`/api/vs/manager/${merchantId}/pmsProfileOptions`
		),
		data
	);
};

const updateProfileOption = (systemSource, merchantId, id, data) => {
	return Client.put(
		systemSourceUrl(
			systemSource,
			`/api/vs/manager/${merchantId}/pmsProfileOptions/${id}`
		),
		data
	);
};

const getBranchSettings = (systemSource, merchantId, data) => {
	return Client.get(
		systemSourceUrl(
			systemSource,
			`/api/vs/manager/branch-setting/${merchantId}`
		),
		data
	);
};

const postBranchSettings = (systemSource, merchantId, data) => {
	return Client.post(
		systemSourceUrl(
			systemSource,
			`/api/vs/manager/branch-setting/${merchantId}`
		),
		data
	);
};

const downloadList = (systemSource, data) => {
	return Client.get(
		systemSourceUrl(systemSource, '/order/list/download'),
		data,
		{
			responseType: 'blob',
		}
	);
};

const getRefundList = (systemSource, merchantId, data) => {
	return Client.get(
		systemSourceUrl(
			systemSource,
			`/api/vs/manage/${merchantId}/omsOrderRefundApplys`
		),
		data
	);
};

const postRefundList = (systemSource, merchantId, data) => {
	return Client.post(
		systemSourceUrl(
			systemSource,
			`/api/vs/manage/${merchantId}/omsOrderRefundApplys`
		),
		data
	);
};

const postDeliveryCloseTime = (systemSource, data) => {
	return Client.post(
		systemSourceUrl(
			systemSource,
			'/api/vs/manager/omsDeliveryCloseTimeSetting'
		),
		data
	);
};

const putDeliveryCloseTime = (systemSource, id, data) => {
	return Client.put(
		systemSourceUrl(
			systemSource,
			`/api/vs/manager/omsDeliveryCloseTimeSettings/${id}`
		),
		data
	);
};

const getAllChannelMenuGroups = (systemSource, merchantId, branchId) => {
	return Client.get(
		systemSourceUrl(
			systemSource,
			`/api/vs/manage-channel-menu-group/${merchantId}/${branchId}/allChannels`
		)
	);
};

const updateChannelMenuGroups = (
	systemSource,
	merchantId,
	branchId,
	channelName,
	data
) => {
	return Client.put(
		systemSourceUrl(
			systemSource,
			`/api/vs/manage-channel-menu-group/${merchantId}/${branchId}/channelMenuGroups/${channelName}`
		),
		data
	);
};

const getBranchChannelMenuGroups = (systemSource, merchantId, branchId) => {
	return Client.get(
		systemSourceUrl(
			systemSource,
			`/api/vs/manage-channel-menu-group/${merchantId}/${branchId}/menu-groups`
		)
	);
};

const syncChannelMenuGroups = (
	systemSource,
	merchantId,
	branchId,
	channelName,
	operateBy
) => {
	return Client.post(
		systemSourceUrl(
			systemSource,
			`/api/vs/manage-channel-menu-group/${merchantId}/${branchId}/syncChannelMenu/${channelName}`
		),
		{ operateBy }
	);
};

const syncAllChannelMenu = (systemSource, merchantId, branchId, operateBy) => {
	return Client.post(
		systemSourceUrl(
			systemSource,
			`/api/vs/manage-channel-menu-group/${merchantId}/${branchId}/syncAllChannelMenu`
		),
		{ operateBy }
	);
};

const getQrTableMenuGroup = (systemSource, merchantId, branchId) => {
	return Client.get(
		systemSourceUrl(
			systemSource,
			`/api/vs/manage-qr-table-menu-group/${merchantId}/${branchId}`
		)
	);
};

const getQrTableMenuGroupTargets = (systemSource, merchantId, branchId) => {
	return Client.get(
		systemSourceUrl(
			systemSource,
			`/api/vs/manage-qr-table-menu-group/${merchantId}/${branchId}/targets`
		)
	);
};

const saveQrTableMenuGroup = (systemSource, merchantId, branchId, data) => {
	return Client.put(
		systemSourceUrl(
			systemSource,
			`/api/vs/manage-qr-table-menu-group/${merchantId}/${branchId}`
		),
		data
	);
};

const toggleQrTableMenuGroup = (
	systemSource,
	merchantId,
	branchId,
	enabled,
	operateBy
) => {
	return Client.put(
		systemSourceUrl(
			systemSource,
			`/api/vs/manage-qr-table-menu-group/${merchantId}/${branchId}/toggle?enabled=${enabled}&operateBy=${encodeURIComponent(
				operateBy ?? ''
			)}`
		)
	);
};

export default {
	list,
	find,
	findReturnItem,
	addNote,
	getOrderRefund,
	getOrderReturnApply,
	getOrderOperateHistory,
	getOrderSettings,
	updateOrderSettings,
	getPreparationTimeList,
	addPreparationTime,
	updatePreparationTime,
	deletePreparationTime,
	getDeliveryTimeList,
	addDeliveryTime,
	addDeliveryTimeSingle,
	updateDeliveryTime,
	deleteDeliveryTime,
	getSpecialDay,
	loadMerchantList,
	loadBranchList,
	mgtBranchListCheckLicense,
	deliveryMethodList,
	deliveryFeeList,
	payMethodList,
	updateBranchOnline,
	updateDeliveryMethod,
	addDeliveryMethod,
	addDeliveryFee,
	updateDeliveryFee,
	deleteDeliveryFee,
	getProfileOption,
	updateProfileOption,
	getBranchSettings,
	postBranchSettings,
	downloadList,
	getRefundList,
	postRefundList,
	postDeliveryCloseTime,
	putDeliveryCloseTime,
	getAllChannelMenuGroups,
	updateChannelMenuGroups,
	getBranchChannelMenuGroups,
	syncChannelMenuGroups,
	syncAllChannelMenu,
	getQrTableMenuGroup,
	getQrTableMenuGroupTargets,
	saveQrTableMenuGroup,
	toggleQrTableMenuGroup,
};
